import { Button, Grid, TextField } from '@mui/material'
import { isEqual } from 'lodash'
import { memo } from 'react'
import { metodoPrograma } from '../../../components/api'
import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import dayjs from 'dayjs'

const createServico = z.object({
  cdServico: z.string().nullable().optional(),
  dsServico: z.string().max(100, { message: 'Nome inválido' }),
  dtFimVigencia: z.string().nullable().optional(),
})

const retornaLocalAtendimento = (u = []) => ({
  cdServico: u?.[0] || null,
  dsServico: u?.[1] || '',
  dtFimVigencia: u?.[2] ? dayjs(u?.[2]).format('YYYY-MM-DD') : null,
})

const Edicao = ({ dados, voltar }) => {
  const { handleSubmit, register } = useForm({
    defaultValues: retornaLocalAtendimento(dados),
    resolver: zodResolver(createServico),
  })
  const salva = async (values) => {
    if (values.dtFimVigencia === null) {
      values.dtFimVigencia = undefined
    }
    const obj = {
      ...values,
      dtFimVigencia: values.dtFimVigencia
        ? dayjs(values.dtFimVigencia).format('YYYY-MM-DD HH:mm:ss')
        : undefined,
    }
    const res = await metodoPrograma('salva', obj)
    if (res.status) voltar()
  }

  return (
    <form onSubmit={handleSubmit(salva)} style={{ width: '100%', padding: 0 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={2}>
          <TextField
            type="number"
            {...register('cdServico')}
            label="Cód Serviço"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={10}>
          <TextField
            {...register('dsServico')}
            label="Serviço"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            type="date"
            InputLabelProps={{ shrink: true }}
            {...register('dtFimVigencia')}
            label="Data Fim Vigência"
            fullWidth
            margin="dense"
            variant="outlined"
          />
        </Grid>
        <Grid
          item
          xs={12}
          style={{ display: 'flex', flexDirection: 'row-reverse' }}
        >
          <Button
            type="submit"
            variant="contained"
            color="primary"
            style={{ margin: '5px' }}
          >
            Salvar
          </Button>
          <Button
            onClick={voltar}
            variant="contained"
            color="secondary"
            style={{ margin: '5px' }}
          >
            Cancelar
          </Button>
        </Grid>
      </Grid>
    </form>
  )
}

export default memo(Edicao, isEqual)
